module.exports = __webpack_public_path__ + "img/activeHyperlink.07ca83f3.svg";